/**
 * Compute a padded numeric domain for estimate + CI + observation markers.
 * Mirrors the padding approach used by LocationViz so metric meaning stays stable.
 */
export function computeMetricRangeDomain(pointEstimate, lowerBound, upperBound, dataPoints = []) {
  const observations = [pointEstimate, lowerBound, upperBound, ...(dataPoints || [])].filter(
    (value) => typeof value === "number" && Number.isFinite(value)
  );

  if (observations.length === 0) {
    return { min: 0, max: 1 };
  }

  const maxObs = Math.max(...observations);
  const minObs = Math.min(...observations);

  let maxNo;
  let minNo;

  if (typeof upperBound === "number" && maxObs > upperBound) {
    maxNo = upperBound + 2 * (maxObs - upperBound);
  } else if (typeof upperBound === "number") {
    maxNo = upperBound / 0.84;
  } else {
    maxNo = maxObs;
  }

  if (typeof lowerBound === "number" && minObs < lowerBound) {
    minNo = lowerBound - 2 * (lowerBound - minObs);
  } else if (typeof lowerBound === "number") {
    minNo = lowerBound * 0.84;
  } else {
    minNo = minObs;
  }

  if (!(maxNo > minNo)) {
    const pad = Math.abs(maxNo || 1) * 0.1 || 1;
    return { min: minNo - pad, max: maxNo + pad };
  }

  return { min: minNo, max: maxNo };
}

export function isMetricRenderable(pointEstimate, upperBound) {
  return typeof pointEstimate !== "undefined" && typeof upperBound !== "undefined";
}
